import React from 'react';
import Icon from '../AppIcon';

// Floating "Contact Support" button — rendered once in App.jsx so it appears
// on every page (public and authenticated) without touching individual page
// files. Reuses the same WhatsApp number and brand styling already used for
// "Register via WhatsApp instead" on transporter-dashboard.
const SUPPORT_WHATSAPP_NUMBER = '917989953468';
const SUPPORT_WHATSAPP_MESSAGE = 'Hi, I need help with SugarHathi';

const ContactSupportButton = () => (
  <a
    href={`https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(SUPPORT_WHATSAPP_MESSAGE)}`}
    target="_blank"
    rel="noreferrer"
    aria-label="Contact Support on WhatsApp"
    style={{
      position: 'fixed',
      bottom: 20,
      right: 20,
      zIndex: 40,
      width: 52,
      height: 52,
      borderRadius: '50%',
      background: '#25D366',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
      textDecoration: 'none',
    }}
  >
    <Icon name="MessageCircle" size={26} color="#fff" />
  </a>
);

export default ContactSupportButton;
